import { render, staticRenderFns } from "./BeaconCreateOrEdit.vue?vue&type=template&id=5e5fb80d&"
import script from "./BeaconCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./BeaconCreateOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports